<div class="style-tabs grid">
  <div class="style-tabs-entries col-2-3">
    <ul>
      <ng-content></ng-content>
    </ul>
  </div>
  <div
    class="style-tabs-content"
    [class.col-4-11]="!isBig"
    [class.col-4-12]="isBig"
  >
    <router-outlet></router-outlet>
  </div>
</div>
